/**
 * Bubble filter utility
 * Filters speech bubbles based on conditions
 */

import type { SceneData, ChoiceCondition } from '../types'
import { evaluateCondition } from '../utils/condition-evaluator'

/**
 * Filter speech bubbles based on their conditions
 * Returns only bubbles that meet their conditions (or have no condition)
 */
export function filterBubblesByCondition(
  speechBubbles: SceneData['speechBubbles'],
  onEvaluateCondition?: (condition: ChoiceCondition) => boolean
): NonNullable<SceneData['speechBubbles']> {
  if (!speechBubbles) return []
  
  const evaluator = onEvaluateCondition || evaluateCondition
  
  return speechBubbles.filter((bubble) => {
    // If no condition, always show the bubble
    if (!bubble.when) return true
    
    // Evaluate condition
    return evaluator(bubble.when)
  })
}
